export const TRANSLATION_KEY = 'gig_page_perseus.contact_hourly_seller_card';
export const INITIAL_TEXT = 'Can we work on an hourly basis on ';
